// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"a1c9a389","845":"bf43aada"}[chunkId] + ".chunk.css";
};